<div>
  <div class="dropdown-mobile--spacer my-5 d-flex justify-content-between">
    <div>
      <ng-container
        *ngIf="!selectedCategory.selected; then allCategoriesHeader else allCategoriesHeaderSubCategories">
      </ng-container>
      <ng-template #allCategoriesHeader>
        <h2 class="ds-heading--s m-0">{{'categories.browse' | cxTranslate}}</h2>
      </ng-template>
      <ng-template #allCategoriesHeaderSubCategories>
        <div (click)="hideSubCategories()"
             (keyup.enter)="hideSubCategories()"
             class="header--sub-categories focusable focusable__element"
             tabindex="0">
          <em class="ds-icon ds-icon--arrow-left flaot-start"></em>
          <span [attr.data-cy]="'subCategoryHeader'" class="ds-body">{{'categories.browse' | cxTranslate}}</span>
        </div>
      </ng-template>
    </div>
    <div class="d-flex flex-column justify-content-center">
      <em (click)="modal.dismiss('Modal close button clicked')"
          (keyup.enter)="modal.dismiss('Modal close button clicked')"
          class="ds-icon ds-icon--close menu-close-button"
          tabindex="0">
      </em>
    </div>
  </div>
</div>
<hr class="mt-0 mb-4">
<div>
  <div class="row">
    <div class="col-12 p-0">
      <ng-container *ngIf="!selectedCategory.selected; then categoryEntries else categorySubEntries"></ng-container>
      <ng-template #categoryEntries>
        <div *ngFor="let category of categories" class="list-group-item-spacing">
          <dcp-category-entry
            (showSubCategoriesEvent)="showSubCategories($event)"
            [category]="category"
            [modal]="modal">
          </dcp-category-entry>
          <hr *ngIf="category.url" class="my-0 mb-1">
        </div>
      </ng-template>
      <ng-template #categorySubEntries>
        <div *ngFor="let category of categories">
          <dcp-category-sub-entries *ngIf="selectedCategory.translationKey === category.translationKey"
                                    [category]="category"
                                    [modal]="modal">
          </dcp-category-sub-entries>
        </div>
      </ng-template>
    </div>
  </div>
</div>
